import { jsxs, jsx } from 'react/jsx-runtime';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { localeValue } from '../constants/localeValues.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import getYearCountInRange from '../utils/getYearCountInRange.mjs';
import ControllerContainer from './base/ControllerContainer.mjs';
import { localeValues } from './localeValues.mjs';

const YearController_NAME = "YearController";
const DatePickerYearController = ({
  children,
  __scopeDatePicker,
  ...props
}) => {
  const {
    mode,
    startDate,
    endDate,
    selectedDate,
    clearSelected,
    excludeDates
  } = useDatePickerContext(YearController_NAME, __scopeDatePicker);
  const { locale } = useLinearLocale();
  const isRangeMode = mode === "range";
  const singleModeCount = !isRangeMode && selectedDate !== null ? 1 : 0;
  const rangeModeCount = isRangeMode && startDate !== null && endDate !== null ? getYearCountInRange(startDate, endDate, excludeDates) : 0;
  const selectedDateCount = Math.max(
    isRangeMode ? rangeModeCount : singleModeCount,
    0
  );
  const rangeLabel = isRangeMode && selectedDateCount > 0 ? localeValue[locale].yearCount(selectedDateCount) : "";
  if (typeof children === "function") {
    return children({
      selectedDateCount,
      isRangeMode
    });
  }
  const notAllowedToClear = isRangeMode ? startDate === null && endDate === null : selectedDate === null;
  return /* @__PURE__ */ jsxs(ControllerContainer, { ...props, children: [
    /* @__PURE__ */ jsx(ControllerContainer.InfoText, { children: isRangeMode && rangeLabel ? rangeLabel : localeValue[locale].optionalInputDescription }),
    /* @__PURE__ */ jsx(
      ControllerContainer.ClearButton,
      {
        disabled: notAllowedToClear,
        onClick: clearSelected,
        children: localeValues[locale].clear
      }
    )
  ] });
};

export { DatePickerYearController as default };
//# sourceMappingURL=YearController.mjs.map
